import { FormErrors } from 'KnmPackage/MainModule/types/FormErrors';
import { makeRequired } from 'CorePackage/MainModule/validators/isRequired';
import { composeValidators, Validator } from 'CorePackage/MainModule/validators/composeValidators';
import { makeNoSoonerThenValidator } from 'CorePackage/MainModule/validators/isNoSoonerThan';
import { formatDate } from 'CorePackage/MainModule/common/formatDate';
import { DATE_FORMAT_LONG_FNS, DATE_FORMAT_LONG_MINUTE_FNS } from 'CorePackage/MainModule/constants/dateFormats';
import { IVideoCallInfo } from 'APIPackage/CatalogsModule/interfaces/IVideoCallInfo';
import { IKnmPmFormRescheduling } from 'KnmPmPackage/MainModule/interfaces/IKnmPmFormRescheduling';
import { makeNoLaterThenValidator } from 'CorePackage/MainModule/validators/isNoLaterThen';

import { IKnmErknmFormRescheduling } from '../interfaces/IKnmErknmFormRescheduling';

export const videoCallInfoValidator = (
  rescheduling: IKnmErknmFormRescheduling[] | IKnmPmFormRescheduling[] | null | undefined,
  startDate?: string,
  stopDate?: string,
) => (videoCallInfo: IVideoCallInfo[] | undefined): FormErrors<IVideoCallInfo>[] | undefined => {
  const newRescheduling = rescheduling?.find(i => i.isNew);

  const validateDateTime = (value: string) => {
    let validators: Validator[] = [];

    if (!newRescheduling) {
      if (!rescheduling?.length) {
        validators = [
          makeNoLaterThenValidator(
            'Дата ВКС не должна быть позже даты окончания проведения мероприятия',
            () => stopDate,
          ),
          makeNoSoonerThenValidator(
            'Дата ВКС не должна быть раньше даты начала проведения мероприятия',
            () => startDate,
          ),
        ];
      }
    } else {
      validators = [
        makeNoLaterThenValidator('Введите новую дату ВКС', () => newRescheduling.newEndDate),
        makeNoSoonerThenValidator('Введите новую дату ВКС', () => newRescheduling.newStartDate),
      ];
    }

    return composeValidators(
      makeRequired('Поле не может быть пустым'),
      ...validators,
    )(
      value
        ? formatDate({ date: value, dateFormat: DATE_FORMAT_LONG_FNS, parseFormat: DATE_FORMAT_LONG_MINUTE_FNS })
        : undefined,
    );
  };

  return videoCallInfo?.map(item => {
    return {
      dateTime: validateDateTime(item.dateTime),
      link: makeRequired('Поле не может быть пустым')(item.link),
    };
  });
};
